export const SILKTIDE_ASSET_VERSION = '20260831-1';